import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { MAX_RETRIES } from '#pplx/frontend/api-clients/core/utils.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
export const getUserInfo = async ({ reason }) => {
    const { error, data, response } = await webserveruserClient.GET('/rest/user/info', reason, {
        timeoutMs: 1500,
        numRetries: MAX_RETRIES,
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: `Failed to get user info`,
            cause: error,
            status: response.status ?? 0,
        });
    }
    return {
        isEnterprise: data.is_enterprise,
        isGov: data.is_gov,
        isStudent: data.is_student,
        studentCountry: data.student_country ?? null,
        hasNonPublicEmail: data.has_non_public_email,
        syntheticUserType: data.synthetic_user_type,
    };
};
//# sourceMappingURL=userInfoQueries.js.map